<template>
  <div class="join-us">
    <div class="join-img">
      <banner-img :type="5"></banner-img>
    </div>
    <div class="p">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>关于我们</el-breadcrumb-item>
      </el-breadcrumb> 
    </div>
    <div class="join-main">
      <leftBox class="left" :navleft="navleft" :navtype="navtype" :p="ptitle"></leftBox>
      <div class="main-right-talented" v-if="$route.name == 'companyProfile'">
        <companyProfileRight></companyProfileRight>
      </div>
      <div v-if="$route.name == 'ProfessionalEngineerIicense'" class="main-right-talented">
        <ProfessionalEngineerIicenseRight></ProfessionalEngineerIicenseRight>
      </div>
      <div v-if="$route.name == 'concatUs'" class="main-right-talented">
        <concatUsRight></concatUsRight>
      </div>
      <div class="main-right-talented" v-if="$route.name == 'talentedPeople'">
        <talentedPeopleRight></talentedPeopleRight>
      </div>
      <div v-if="$route.name == 'agentInvestment'" class="main-right-talented">
        <agentInvestmentRight></agentInvestmentRight>
      </div>
      <div
        class="main-right-talented"
        v-if="$route.meta.title == '企业公告详情'"
      >
        <CorporateAnnouncementsDetail></CorporateAnnouncementsDetail>
      </div>
    </div>
    <div class="rightfixed">
      <ul :class="searchBarFixed == true ? 'isFixed' : ''">
        <rightFixed></rightFixed>
      </ul>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Bottom from '../../components/bottom'
import leftBox from "../../components/leftBox";
import rightFixed from "../productCenter/components/rightFixed";
import concatUsRight from "./concatUs/components/right";
import ProfessionalEngineerIicenseRight from "./ProfessionalEngineerIicense/components/right";
import companyProfileRight from "./companyProfile/components/right";
import talentedPeopleRight from "./talentedPeople/components/right";
import agentInvestmentRight from "./agentInvestment/components/right";
export default {
  name: "join-us",
  data() {
    return {
      searchBarFixed: false,
      offsetTop: 0,
      ptitle:'关于我们',
      navtype:'three',
      navleft: [
        {
          title: "关于百生跃",
          url: "/aboutUs/companyProfile",
        },
        // {
        //   title: "关于麦克林",
        //   url: "/aboutUs/ProfessionalEngineerIicense",
        // },
        {
          title: "联系我们",
          url: "/aboutUs/concatUs",
        },
        {
          title: "诚聘英才",
          url: "/aboutUs/talentedPeople",
        },
        {
          title: "代理招商",
          url: "/aboutUs/agentInvestment",
        }
      ],
    };
  },
  components: {
    Bottom,
    leftBox,
    rightFixed,
    concatUsRight,
    ProfessionalEngineerIicenseRight,
    companyProfileRight,
     talentedPeopleRight,
    agentInvestmentRight,
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector(".rightfixed").offsetTop;
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.join-us {
  width: 1920px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  position: relative;
  .rightfixed {
    width: 90px;
    height: 230px;
    position: absolute;
    top: 550px;
    right: 10px;
    .isFixed {
      position: fixed;
      bottom: 150px;
      z-index: 999;
    }
  }
  .box-one {
    width: 1510px;
    height: 316px;
    background: #f6f6f6;
    margin: auto;
    background: url("../../images/four.png");
  }
  .p{
    font-size: 14px;
    margin: 26px 0px 20px 335px;
    color: #666666;
    height:19px;
    line-height: 19px;
    /deep/.el-breadcrumb__inner.is-link{
      color:#666666;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: normal;
    }
    /deep/ .el-icon-arrow-right{
      color:#666666;
    }
    /deep/ .el-breadcrumb__inner{
      cursor: pointer;
    }
  }
  .join-main {
    width: 1510px;
    background: #ffffff;
    margin: auto;
    margin-bottom: 20px;
    display: flex;
    .left {
      margin-left: 130px;
    }
    .main-right-talented {
      width: 876px;
      background: #ffffff;
      margin-top: 44px;
      margin-left: 61px;
    }
  }
  .join-img {
    width: 100%;
    img {
      width: 1920px;
      height: 300px;
    }
  }
  .five {
    width: 805px;
    height: 49px;
    margin: auto;
    margin-top: 15px;
    font-size: 14px;
    text-align: center;
    color: #666666;
    line-height: 24px;
    span {
      font-size: 14px;
      text-align: center;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>